module.exports = __webpack_public_path__ + "img/logo-tropical.70441310.png";